import WithRender from "../../templates/buttons/uploadButton.html";
import { mapActions, mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getShowUpload"]),
    name: function () {
      return this.getShowUpload ? "Cancel uploading" : "Upload";
    }
  },
  methods: {
    ...mapActions(["setShowUpload"]),
    onToggleUpload: function () {}
  }
});
